import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: import.meta.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash === '#product' || from.hash === '#product') {
            return;
        }

        if (savedPosition) {
            return savedPosition;
        }

        return { x: 0, y: 0 };
    }
});

router.beforeEach(async (to, from, next) => {
    // if (!store.state.location.geolocation) {
    //     geolocation.getCurrentPosition(function (err, position) {
    //         if (err) {
    //             return false;
    //         } else {
    //             store.dispatch('location/setGeolocation', position);
    //         }
    //     })
    // }

    next();
});

router.afterEach((to, from) => {
    if (to.path === from.path && to.hash !== from.hash) {
        return;
    }

    if (Vue.prototype.$analytics) {
        Vue.prototype.$analytics.page({
            path: to.path,
            url: window.location.href,
            title: document.title,
            name: to.name
        });
    }

    if (import.meta.env.VITE_APP) {
        import('@/native/appBridge').then(({ sendToNative }) => {
            sendToNative('ROUTE_CHANGE', {
                path: to.path,
                name: to.name,
                params: to.params,
                query: to.query,
                fullPath: to.fullPath,
                from: {
                    path: from.path,
                    name: from.name,
                    fullPath: from.fullPath
                }
            });
        });
    }
});

export default router;
